import { schedulePostPaint } from "~/lib/schedule-post-paint";

/**
 * Warm the symbol page's (shared, ~108 KB minified) code chunk from a list
 * page whose rows all link into it — the list→asset click is the app's most
 * common navigation, and the shell must be ready before any click.
 *
 * Politeness rules (review feedback on PR #6349):
 * - Skipped when the parent route is merely intent-preloaded — only a real
 *   mount of the list page warms the chunk.
 * - Deferred past the list page's own paint (idle slice, 1.5s hard fallback,
 *   4s idle grace) so it never competes with the page users are looking at.
 * - Best-effort: failures stay silent; a later hover/click retries the import.
 */
export function warmSymbolShellFromListRoute(preload: boolean): void {
  if (preload) {
    return;
  }

  schedulePostPaint(
    () => {
      import("~/features/symbol/page").catch(() => {
        // Best-effort warmup; navigation retries the import on demand.
      });
    },
    1_500,
    4_000,
  );
}
